import requestService from "../requestService";
import store from '@/store';

export default {
    async createBanner(form) {
        const response = await requestService.post(`/admin/photos/create`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async updateBanner(uuid, form) {
        const response = await requestService.post(`/admin/photos/${uuid}/update`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getBanners() {
        const response = await requestService.get(`/photos`)
        return response?.data
    },
    async getBanner(id) {
        const response = await requestService.get(`/admin/photos/${id}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async deleteBanner(id) {
        const response = await requestService.delete(`/admin/photos/${id}/delete`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
}